<template>
  <div id="categorias">
    <b-row>
      <b-col>
        <h4>{{ title }}</h4>
      </b-col>
      <export-excel
        :header="excelExportColumns"
        :listado="items"
        :filename="'Histórico_Compras_' + type + '.xlsx'"
        variant="link"
      />
    </b-row>
    <DataTableNaf
      :items="items"
      :fields="fields"
      :is-fetching="isFetching"
      :per-page="5"
      :grid-cols="gridCols"
      :is-compact="isCompactTable"
      compact-fields="nombre"
      @onRowClick="handleClickRow"
    >
      <template #cell(codigo)="{ item }">
        <span>{{ item.codigo }}</span>
      </template>
      <template #cell(nombre)="{ item }">
        <span> {{ item.nombre }} </span>
      </template>
      <template #cell(cantidadrecibida)="{ item }">
        <span>{{ $n(item.cantidadrecibida, 'unidades') }}</span>
      </template>
      <template #cell(pvf)="{ item }">
        <span> {{ $n(parseFloat(item.pvf), 'currency') }} </span>
      </template>
      <template #cell(pvl)="{ item }">
        <span> {{ $n(parseFloat(item.pvl), 'currency') }} </span>
      </template>
    </DataTableNaf>
  </div>
</template>

<script>
export default {
  name: 'Categorias',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Título por defecto',
    },
    uniquekey: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'listado',
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCompactTable: false,
      fields: [],
      fieldsDato: [
        {
          key: 'nombre',
          sortable: true,
          label: 'Nombre',
          header: 'Nombre',
          tooltip: '',
        },
        {
          key: 'cantidadrecibida',
          sortable: true,
          label: 'Cantidad Recibida',
          header: 'Cantidad Recibida',
          tooltip: '',
        },
        {
          key: 'pvf',
          sortable: true,
          label: 'PVF',
          header: 'PVF',
          tooltip: '',
        },
        {
          key: 'pvl',
          sortable: true,
          label: 'PVL',
          header: 'PVL',
          tooltip: '',
        },
      ],
      excelExportColumns: [
        {
          key: 'nombre',
          sortable: false,
          label: 'Nombre',
        },
        {
          key: 'cantidadrecibida',
          sortable: false,
          label: 'Cantidad recibida',
        },
        {
          key: 'pvf',
          sortable: true,
          label: 'PVF',
        },
        {
          key: 'pvl',
          sortable: true,
          label: 'PVL',
        },
      ],
      gridCols: '2fr 1fr 1fr 1fr',
    };
  },
  mounted() {
    this.isCompactTable = window.innerWidth < 992;
    if (this.type === 'Artículo') {
      this.fieldsDato.unshift({
        key: 'codigo',
        sortable: true,
        label: 'Código',
        header: 'Código',
      });
      this.excelExportColumns.unshift({
        key: 'codigo',
        sortable: false,
        label: 'Código',
      });
      this.gridCols = '1fr 2fr 1fr 1fr 1fr';
    }
    this.fields = this.fieldsDato;
    window.addEventListener('resize', this.handleUpdateScreenSize);
  },
  methods: {
    handleClickRow: function (row) {
      this.$emit('rowClick', row);
    },
    handleUpdateScreenSize: function () {
      this.isCompactTable = window.innerWidth < 992;
    },
  },
};
</script>

<style scoped lang="scss">
#categorias {
  h4 {
    span {
      color: var(--fc-brand-01);
      text-transform: lowercase;
    }
  }
  @media screen and (max-width: 992px) {
    ::v-deep .compact-fields {
      display: flex;
      flex-wrap: wrap;
    }
    ::v-deep .grid {
      grid-template-columns: none !important;
      justify-content: start;
    }
  }
}
</style>
